import type { OperationVariables, UseFragmentOptions } from '@apollo/client';
import type { EventId } from '@ps/web-sports-api-types';
import type { Required as Require } from 'utility-types';

import { FixtureFragmentDoc, MatchFragmentDoc } from '@swf/generated/graphql/scoreboards/hooks';

import { EventTypeId } from '../types/eventType';

import type { ScoreboardData } from './getScoreboardType';

/**
 * "Require" football to avoid it possibly being "undefined".
 * "Partial" to avoid including all event types.
 */
type EventTypeScoreboardFragmentMap = Require<
  Partial<
    Record<
      EventTypeId,
      (eventId: EventId) => UseFragmentOptions<ScoreboardData, OperationVariables>
    >
  >,
  EventTypeId.SOCCER
>;

const eventTypeScoreboardFragmentMap: EventTypeScoreboardFragmentMap = {
  [EventTypeId.SOCCER]: (eventId) => ({
    fragment: FixtureFragmentDoc,
    fragmentName: 'Fixture',
    from: {
      __typename: 'FootballFixture',
      id: eventId
    }
  }),
  [EventTypeId.TENNIS]: (eventId) => ({
    fragment: MatchFragmentDoc,
    fragmentName: 'Match',
    from: {
      __typename: 'TennisMatch',
      id: eventId
    }
  })
};

export const getEventScoreboardFragment = (eventTypeId: EventTypeId, eventId: EventId) =>
  eventTypeScoreboardFragmentMap[eventTypeId]?.(eventId) ??
  eventTypeScoreboardFragmentMap[EventTypeId.SOCCER](0);
